/**
 * Guest-facing Speisekarte order tokens (Nr.) — not allergen letters.
 * Printed DE menus use "01", "10b", "D1", "K1"; rarely the word "Nr.".
 */
export function normalizeGuestMenuItemCode(raw: string | null | undefined): string {
  let value = raw?.trim() ?? '';
  if (!value) return '';

  value = value.replace(/^(?:nr|no|n°|nº|num(?:mer)?)\.?\s*/i, '');
  value = value.replace(/^#\s*/, '');
  value = value.replace(/[.)]+$/g, '');
  value = value.trim();

  if (/^\d$/.test(value)) {
    value = value.padStart(2, '0');
  }

  return value.slice(0, 32);
}
